import { afterRenderEffect, Directive, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

@Directive({
  selector: '[wcgViewPortScroll]',
})
export class ViewPortScrollDirective {
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _$fragment = toSignal(
    this._activatedRoute.fragment?.pipe(map((fragment) => fragment)),
  );
  constructor() {
    afterRenderEffect(() => {
      const _fragment = this._$fragment();
      if (_fragment) {
        queueMicrotask(() => {
          const el = document.getElementById(_fragment);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        });
      } else {
        // if element is not found, scroll to top
        window.scrollTo({ behavior: 'smooth', top: 0 });
      }
    });
  }
}
